module.exports = __webpack_public_path__ + "static/media/Hamburguesa.3e2843ac.png";